import {
  Box,
  Center,
  HStack,
  Stack,
  StackProps,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { FaInfoCircle } from "react-icons/fa";

export interface QuickFactProps extends StackProps {
  title: string; // the title of the fact
  stat: string | number; // the statistic or value displayed on the stat
  metric: string; // the descriptor, unit, or metric used to provide more info on the stat
  color?: string;

  helpText?: string;
}

export const QuickFact = (props: QuickFactProps) => {
  const { title, stat, metric, helpText, ...rest } = props;

  return (
    <Stack
      as="dl"
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing="3"
      minW="3xs"
      minH="3xs"
      px="3"
      py="4"
      bg="white"
      borderRadius="lg"
      cursor="pointer"
      shadow="lg"
      {...rest}
    >
      <HStack alignItems="center">
        <Text
          as="dt"
          color="black"
          fontSize="md"
          fontWeight="medium"
          align="center"
        >
          {title}
        </Text>
        {helpText && (
          <Tooltip
            label={helpText}
            placement="right"
            hasArrow
            bg={props?.color || "blue.600"}
            color="white"
          >
            <Box
              fontSize="sm"
              color="subtle"
              _hover={{
                color: props?.color || "blue.600",
              }}
            >
              <Box as={FaInfoCircle} />
            </Box>
          </Tooltip>
        )}
      </HStack>
      <Center
        h="6rem"
        w="8rem"
        bg={props?.color || "blue.600"}
        borderRadius="10"
        textAlign="center"
      >
        <Text as="dd" color="white" fontWeight="bold" fontSize="2xl">
          {stat}
        </Text>
      </Center>
      <Text as="dd" color="subtle" align="center" fontSize="xs">
        {metric}
      </Text>
    </Stack>
  );
};
